var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkCircle = function SvgLinkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    fillRule: "evenodd",
    d: "M6.275 34.227c2.44 2.44 6.369 2.44 14.226 2.44 7.856 0 11.785 0 14.226-2.44 2.44-2.441 2.44-6.37 2.44-14.226s0-11.785-2.44-14.226-6.37-2.441-14.226-2.441-11.785 0-14.226 2.44c-2.441 2.442-2.441 6.37-2.441 14.227 0 7.856 0 11.785 2.44 14.226m10.059-19.643a5.417 5.417 0 1 0 5.417 5.417 1.25 1.25 0 1 1 2.5 0 7.917 7.917 0 1 1-7.917-7.917 1.25 1.25 0 0 1 0 2.5m13.75 5.417a5.417 5.417 0 0 1-5.417 5.416 1.25 1.25 0 0 0 0 2.5 7.917 7.917 0 1 0-7.916-7.916 1.25 1.25 0 0 0 2.5 0 5.417 5.417 0 1 1 10.833 0",
    clipRule: "evenodd"
  })));
};
export default SvgLinkCircle;